import { Link } from 'react-router-dom';

const LOGO_URL = 'https://static.readdy.ai/image/1e1522e14c640395ed26d10e936fd941/2c36f21ce67591e9de99c399e19fe8d5.png';

export default function Footer() {
  return (
    <footer>
      {/* Top Footer */}
      <div className="bg-[#f8f9fc] py-14 border-t border-gray-200">
        <div className="max-w-screen-xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Column 1 */}
          <div>
            <h4 className="text-[#0b2240] font-bold text-base mb-4">Insurance Solutions</h4>
            <div className="w-12 h-0.5 bg-[#3072b7] mb-5" />
            <ul className="space-y-2.5">
              {[
                { label: 'Personal Insurance', href: '/insurance-solutions#personal' },
                { label: 'Business Insurance', href: '/insurance-solutions#business' },
                { label: 'Insurance by Industry', href: '/insurance-solutions#industry' },
                { label: 'Explore Interactive Graphics', href: '/insurance-solutions' },
                { label: 'Insurance Companies', href: '/about#companies' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="text-sm text-gray-600 hover:text-[#3072b7] transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="text-[#0b2240] font-bold text-base mb-4">About Our Agency</h4>
            <div className="w-12 h-0.5 bg-[#3072b7] mb-5" />
            <ul className="space-y-2.5">
              {[
                { label: 'About Our Agency', href: '/about' },
                { label: 'Meet Our Team', href: '/about#team' },
                { label: 'Read Our Reviews', href: '/about#reviews' },
                { label: 'We Are Independent', href: '/about#independent' },
                { label: 'Join Our Team', href: '/about#careers' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="text-sm text-gray-600 hover:text-[#3072b7] transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h4 className="text-[#0b2240] font-bold text-base mb-4">Get Help</h4>
            <div className="w-12 h-0.5 bg-[#3072b7] mb-5" />
            <ul className="space-y-2.5">
              {[
                { label: 'Report a Claim', href: '/service-center#claim' },
                { label: 'Request Auto ID Card', href: '/service-center#auto-id' },
                { label: 'Request a Certificate', href: '/service-center#certificate' },
                { label: 'Request Policy Change', href: '/service-center#policy-change' },
                { label: 'Contact Us', href: '/contact' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="text-sm text-gray-600 hover:text-[#3072b7] transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-[#0b2240] py-10">
        <div className="max-w-screen-xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          {/* Contact Card */}
          <div className="bg-white border-t-4 border-[#3072b7] rounded-b-lg p-8 shadow-sm">
            <h4 className="text-[#0b2240] font-bold text-lg mb-1">Contact Us</h4>
            <p className="text-gray-500 text-sm mb-4">406 Hemphill St<br />Hattiesburg, MS 39401</p>
            <div className="w-16 h-0.5 bg-[#3072b7] mb-4" />
            <div className="space-y-2 text-sm text-gray-600">
              <p>
                <i className="ri-phone-line text-[#3072b7] mr-2" />
                <a href="tel:6013259000" className="hover:text-[#3072b7]">601-325-9000</a>
              </p>
              <p>
                <i className="ri-mail-line text-[#3072b7] mr-2" />
                <a href="mailto:cameron@whiteoakig.com" className="hover:text-[#3072b7]">cameron@whiteoakig.com</a>
              </p>
              <p>
                <i className="ri-time-line text-[#3072b7] mr-2" />
                Office Hours: 9–5, M–F
              </p>
            </div>
            <div className="flex gap-4 mt-5">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#3072b7] text-[#3072b7] hover:bg-[#3072b7] hover:text-white transition-colors">
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#3072b7] text-[#3072b7] hover:bg-[#3072b7] hover:text-white transition-colors">
                <i className="ri-linkedin-fill text-sm" />
              </a>
            </div>
            <Link
              to="/contact"
              className="mt-5 block w-full text-center bg-[#3072b7] hover:bg-[#0b2240] text-white text-sm font-bold py-3 rounded-md transition-colors"
            >
              Visit Our Office
            </Link>
          </div>

          {/* Brand Message */}
          <div className="text-white">
            <img src={LOGO_URL} alt="White Oak Insurance Group" className="h-12 w-auto object-contain mb-5 brightness-0 invert" />
            <h3 className="text-xl font-bold mb-3">Experience the White Oak Insurance Difference</h3>
            <div className="w-16 h-0.5 bg-[#9cbde5] mb-4" />
            <p className="text-white/80 text-sm leading-relaxed mb-3">
              Our goal is to serve as your dedicated insurance advocate and advisor, collaborating with a wide range of top-rated national and regional insurance carriers to identify the most suitable solutions for your insurance and risk management needs.
            </p>
            <p className="text-white/80 text-sm mb-6">
              We are licensed in Mississippi.
            </p>
            <p className="text-white/50 text-xs">
              © {new Date().getFullYear()} White Oak Insurance Group. All rights reserved. |{' '}
              <Link to="/contact" className="hover:text-white transition-colors">Privacy Policy</Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
